import _ from 'lodash'

const getName = user => {
  const displayName = _.get(user, 'displayName')
  if (!displayName) return user.email

  return `${user?.displayName ?? ''} ${user?.familyName ?? ''}`.trim()
}

const buildUser = user => ({
  ...user,
  name: getName(user),
  shortenedName: getShortenedName(user),
  avatarMediaObject: _.get(user, 'photo', null),
})

const buildCollaborator = user => {
  return buildUser(user)
}

const getShortenedName = user => {
  const name = _.get(user, 'displayName', '')
  const lastName = _.get(user, 'familyName', '')
  const email = _.get(user, 'email', '')

  if (!name) return getTruncatedEmail(email)

  return `${getFirstWord(name)} ${getFirstWord(lastName)}`
}

const getTruncatedEmail = email => {
  return `${email
    .split('')
    .slice(0, 8)
    .join('')}...`
}

const getFirstWord = name => {
  return _.first(name.split(' '))
}

const getters = {
  rev: function(state) {
    return state.rev
  },

  availableCoaches: function(state) {
    const availableCoaches = state.availableCoaches || []
    return availableCoaches.map(buildUser)
  },

  availableCollaborators: function(state) {
    const availableCollaborators = state.availableCollaborators || []
    return availableCollaborators.map(buildCollaborator)
  },

  availableOwners: function(state) {
    const availableOwners = state.availableOwners || []
    return availableOwners.map(buildCollaborator)
  },

  revLikes: function(state) {
    return _.get(state.rev, 'likes', [])
  },

  getRev: function(state) {
    return state.rev
  },

  revPoints: function(state) {
    return state.rev.points
  },

  owner: function(state) {
    return buildUser(state.rev.team.owner)
  },

  coach: function(state) {
    const coach = _.get(state.rev, 'team.coach')
    return coach ? buildUser(coach) : null
  },

  collaborators: function(state) {
    const collaborators = state.rev.team.collaborators || []

    return collaborators.map(buildCollaborator)
  },
}

export default getters
